import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const initialState = fromJS({
  tenantInfo: {},
  teamMembers: [],
  teamPipelines: [],
  pending: true,
});

export const actions = {
  [ActionTypes.getBuildInfo]: {
    next(state, { payload, error, pending }) {
      if (error || payload == null || payload === undefined) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      const newState = {
        ...state.toJS(),
        tenantInfo: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getTeamMembers]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        teamMembers: payload,
      };
      return fromJS(newState);
    },
  },
  [ActionTypes.getTeamPipelines]: {
    next(state, { payload, error, pending }) {
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload == null || payload === undefined) {
        return state.merge({ pending, error });
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        teamPipelines: payload,
      };
      return fromJS(newState);
    },
  },
};

export const tenant = handleActions(actions, initialState);
